/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/hooks/useLessonQuizMeSection.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { useMemo } from 'react';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { useLessonQuizMe } from './useLessonQuizMe.migrated';
import { isVideoAsset } from '../../tracks/tracksUtils';
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/interactiveEducation/hooks/useLessonQuizMeSection.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useLessonQuizMeSection = ({
  lesson
}) => {
  var _lesson$content$filte;
  const {
    isNotLaptop
  } = useMediaQuery();
  const {
    allVideosHaveCaptions,
    captionsExistMap,
    captionsLoading,
    generateQuizLoading,
    generateQuizError,
    regenerate: regenerateQuiz,
    regenerateSingleVideoQuiz,
    retryQuizGeneration
  } = useLessonQuizMe({
    lesson
  });
  const lessonQuizProps = useMemo(() => ({
    captionsExistMap,
    generateQuizLoading,
    generateQuizError,
    regenerateQuiz,
    regenerateSingleVideoQuiz
  }), [captionsExistMap, generateQuizLoading, generateQuizError, regenerateQuiz, regenerateSingleVideoQuiz]);
  const videoCount = (_lesson$content$filte = lesson === null || lesson === void 0 ? void 0 : lesson.content.filter(isVideoAsset).length) !== null && _lesson$content$filte !== void 0 ? _lesson$content$filte : 0;
  const preAssessmentAvailable = isNotLaptop && !captionsLoading && allVideosHaveCaptions && videoCount > 1;
  return {
    lessonQuizProps,
    preAssessmentAvailable,
    retryQuizGeneration
  };
};